<efx-modal
  [title]="''"
  [(show)]="isLoadingBoolean"
  [showFooter]="false"
  [showClose]="false"
  [size]="modalSize.small"
>
  <div class="spin-ring d-flex justify-content-center">
    <span class="spinner"></span>
  </div>
  <div class="d-block">
    <div class="d-flex justify-content-center">
      <label class="efx-label">Cargando información, por favor espere...</label>
    </div>
    <div class="d-flex justify-content-center">
      <button class="efx-button-secondary" (click)="onCancelUrl()">Cancelar solicitud</button>
    </div>
  </div>
</efx-modal>
